import React from "react";
import "../../assets/css/international.css";
import { motion } from "framer-motion";

export default function International() {

  const places = [
    {
      name: "Thailand",
      img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
    },
    {
      name: "Vietnam",
      img: "https://images.unsplash.com/photo-1528127269322-539801943592"
    },
    {
      name: "Dubai",
      img: "https://images.unsplash.com/photo-1508057198894-247b23fe5ade"
    },
    {
      name: "Malaysia",
      img: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9"
    },
    {
      name: "Cambodia",
      img: "https://cdn.britannica.com/24/77424-050-4FF80B58/Angkor-Wat-Cambodia.jpg"
    }
  ];

  return (
    <section className="international">

      {/* Background glow */}
      <div className="intl-bg one"></div>
      <div className="intl-bg two"></div>

      <div className="intl-container">

        {/* Header */}
      <motion.h2
  className="intl-title"
  initial={{ opacity: 0, y: 60 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
>
  ✈️ Explore{" "}
  <span className="animated-text">International Tours</span>

  {/* Animated underline */}
  <motion.div
    className="title-underline"
    initial={{ width: 0 }}
    whileInView={{ width: "60%" }}
    transition={{ duration: 0.8, delay: 0.3 }}
  ></motion.div>
</motion.h2>

        <motion.p 
          className="intl-sub"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          Discover the world beyond borders 🌍
        </motion.p>

        {/* Cards */}
        <div className="intl-grid">
          {places.map((place, i) => (
            <motion.div
              className="intl-card"
              key={i}
              whileHover={{ scale: 1.07 }}
            >
              <img src={place.img} alt={place.name} />

              <div className="intl-overlay">
                <h3>{place.name}</h3>
                <p>View Packages →</p>
              </div>

              <div className="intl-glow"></div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}